const colors = {
  // Miso Blue
  blue: '#055CF5',
  blueLight: '#EFF7FF',
  blueDark: '#0A30A8',
  blueExtralight: '#E9F4FF',

  newBlueLight: '#DEF',

  // Miso Black
  black: '#080808',
  defaultBlack: '#000000',

  // Miso White
  white: '#FFFFFF',

  // Miso Grey
  greyModal: '#2E3035',
  greyDark: '#62656A',
  greyMedium: '#A3A7AE',
  greyMediumLight: '#C7CAD0',
  greyLight: '#E3E5EA',
  greyExlight: '#F3F4F8',

  grey01: '#2E3035',
  grey02: '#62656A',
  grey03: '#A3A7AE',
  grey06: '#F3F4F8',

  gray10: '#3A3E4A',
  gray20: '#5F6673',
  gray30: '#AAB3C2',
  gray40: '#C7CEDC',
  gray50: '#E3E7F0',
  gray60: '#EBEFF5',
  gray70: '#F2F5FA',
  gray80: '#F9F9FB',

  // Category Colors
  skyblue: '#38ABFF',
  navy: '#004AE1',
  purple: '#6B4CED',
  turquoise: '#00C8C1',
  yellow: '#FFC81F',
  indigo: '#0F206E',
  red: '#ED5A4D',
  green: '#AFE532',
  officeBlue: '#86BEFF',
  salmon: '#FFF0E9',
};

const mediaQuery = (maxWidth: number) => `
  @media (max-width: ${maxWidth}px)
`;

const media = {
  xxxlarge: mediaQuery(2200),
  xxlarge: mediaQuery(1920),
  xlarge: mediaQuery(1440),
  large: mediaQuery(1200),
  medium: mediaQuery(1024),
  small: mediaQuery(768),
  xsmall: mediaQuery(375),
  custom: mediaQuery,
};

export { media, colors };
